// Youssef Selkani
// 2019

import React, { Component } from 'react'
import '../../App.css'
import { Grid, Header, Segment, Button } from 'semantic-ui-react'

export default class SmartComponents extends Component {
  render () {
    return (
      <div>
        <Grid stackable verticalAlign='top' className='mt'>
          <Grid.Column width='5'>
            <Segment
              onClick={() => this.props.newSmartComp('text')}
              className='cursor'
              fluid={true}>
              <Header as='h4'>
                Text
                <Header.Subheader>Rich formatted text</Header.Subheader>
              </Header>
            </Segment>
          </Grid.Column>
          <Grid.Column width='5'>
            <Segment
              className='cursor'
              onClick={() => this.props.newSmartComp('phone')}
              fluid={true}>
              <Header as='h4'>
                Phone
                <Header.Subheader>Open default phone app</Header.Subheader>
              </Header>
            </Segment>
          </Grid.Column>
          <Grid.Column width='5'>
            <Segment
              onClick={() => this.props.newSmartComp('email')}
              className='cursor'
              fluid={true}>
              <Header as='h4'>
                Email
                <Header.Subheader>Open default email app</Header.Subheader>
              </Header>
            </Segment>
          </Grid.Column>
          <Grid.Column width='5'>
            <Segment
              onClick={() => this.props.newSmartComp('address')}
              className='cursor'
              fluid={true}>
              <Header as='h4'>
                Address
                <Header.Subheader>Open default maps app</Header.Subheader>
              </Header>
            </Segment>
          </Grid.Column>
          <Grid.Column width='5'>
            <Segment onClick={() => this.props.newSmartComp('url')} className='cursor' fluid={true}>
              <Header as='h4'>
                URL
                <Header.Subheader>Open default browser</Header.Subheader>
              </Header>
            </Segment>
          </Grid.Column>

          <Grid.Column width='5'>
            <Segment
              fluid={true}
              className='cursor'
              onClick={() => this.props.newSmartComp('image')}>
              <Header as='h4'>
                Image
                <Header.Subheader>JPEG, PNG or GIF</Header.Subheader>
              </Header>
            </Segment>
          </Grid.Column>

          <Grid.Column width='5'>
            <Segment
              onClick={() => this.props.newSmartComp('video')}
              className='cursor'
              fluid={true}>
              <Header as='h4'>
                Video
                <Header.Subheader>YouTube or video url</Header.Subheader>
              </Header>
            </Segment>
          </Grid.Column>

          <Grid.Column width='5'>
            <Segment
              onClick={() => this.props.newSmartComp('audio')}
              className='cursor'
              fluid={true}>
              <Header as='h4'>
                Audio
                <Header.Subheader>Mini Audio player</Header.Subheader>
              </Header>
            </Segment>
          </Grid.Column>

          <Grid.Column width='5'>
            <Segment
              // onClick={() => this.props.newSmartComp('chart')}
              className='cursor'
              fluid={true}>
              <Header as='h4'>
                Chart
                <Header.Subheader>Display Bar or Line Chart</Header.Subheader>
              </Header>
            </Segment>
          </Grid.Column>
        </Grid>
      </div>
    )
  }
}
